import React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import { trMoney } from '../../utils/accountingFormat';
import EmptyStateCard from '../expense/EmptyStateCard';

function paymentTypeLabel(row) {
  if (row.packageName) return row.packageName;
  if (row.paymentType === 'SESSION') return row.activityName || 'Seans odemesi';
  if (row.paymentType === 'PACKAGE') return 'Paket odemesi';
  if (row.paymentType === 'GENERAL') return 'Genel odeme';
  return row.paymentType || '-';
}

function paymentMethodLabel(method) {
  const value = String(method || '').toUpperCase();
  if (value === 'CASH') return 'Nakit';
  if (value === 'CARD') return 'Kart';
  if (value === 'TRANSFER') return 'Havale/EFT';
  return method || '-';
}

export default function IncomePaymentsCard({
  rows = [],
  onOpenMember,
  onViewPayment,
  onEditPayment,
}) {
  return (
    <Card
      sx={{
        borderRadius: '18px',
        border: '1px solid rgba(0,0,0,0.08)',
        boxShadow: 'none',
        overflow: 'hidden',
      }}
    >
      <MDBox sx={{ px: 1.25, py: 1.1 }}>
        <MDTypography variant="button" fontWeight="bold">
          Son Alinan Odemeler
        </MDTypography>
        <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
          Tahsil edilen odeme hareketleri
        </MDTypography>
      </MDBox>

      <Divider />

      <MDBox sx={{ p: 1.25, display: 'grid', gap: 0.8 }}>
        {!rows.length ? (
          <EmptyStateCard
            icon="payments"
            title="Odeme kaydi yok"
            desc="Secilen filtreye uygun odeme bulunamadi."
          />
        ) : (
          rows.map((row) => (
            <MDBox
              key={row.paymentId ?? `${row.fullName}-${row.paidDate}-${row.amountTry}`}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                p: 1,
                borderRadius: '14px',
                border: '1px solid rgba(0,0,0,0.06)',
                flexWrap: 'wrap',
              }}
            >
              <MDBox sx={{ minWidth: 0, flex: 1 }}>
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  onClick={() => onOpenMember?.(row)}
                  sx={{
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    textDecorationStyle: 'dotted',
                  }}
                >
                  {row.fullName || row.payerName || 'Isimsiz odeme'}
                </MDTypography>

                <MDTypography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                  {[paymentTypeLabel(row), paymentMethodLabel(row.method), row.paidDate || '-']
                    .filter(Boolean)
                    .join(' • ')}
                </MDTypography>

                {(row.trainerName || row.activityName) && (
                  <MDTypography
                    variant="caption"
                    sx={{ color: 'text.secondary', display: 'block' }}
                  >
                    {row.trainerName ? `Egitmen: ${row.trainerName}` : ''}
                    {row.trainerName && row.activityName ? ' • ' : ''}
                    {row.activityName ? `Aktivite: ${row.activityName}` : ''}
                  </MDTypography>
                )}

                {row.note && (
                  <MDTypography
                    variant="caption"
                    sx={{ color: 'text.secondary', display: 'block' }}
                  >
                    {row.note}
                  </MDTypography>
                )}
              </MDBox>

              <MDBox sx={{ display: 'flex', alignItems: 'center', gap: 0.8, flexWrap: 'wrap' }}>
                <Chip
                  size="small"
                  color="success"
                  label={trMoney(row.amountTry || 0)}
                  sx={{ fontWeight: 900 }}
                />

                {onViewPayment ? (
                  <Button
                    size="small"
                    startIcon={<Icon fontSize="small">visibility</Icon>}
                    onClick={() => onViewPayment(row)}
                  >
                    Detay
                  </Button>
                ) : null}

                {onEditPayment ? (
                  <Button
                    size="small"
                    startIcon={<Icon fontSize="small">edit</Icon>}
                    onClick={() => onEditPayment(row)}
                  >
                    Duzenle
                  </Button>
                ) : null}
              </MDBox>
            </MDBox>
          ))
        )}
      </MDBox>
    </Card>
  );
}
